import { useSnackbar } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ComplianceChecklistItemStatus } from '../../../../generated/core-api/graphql-react-query';
import sendNotification from '../../../../notifications/sendNotification';
import { SessionComplianceChecklistItem } from '../Contexts/SessionComplianceContextProvider/type';
import useSessionComplianceContext from '../Contexts/SessionComplianceContextProvider/useSessionComplianceContext';

export default function useComplianceRejection() {
  const complianceChecklist = useSessionComplianceContext();
  const { t } = useTranslation('notifications');
  const { enqueueSnackbar } = useSnackbar();
  const rejectedComplianceTasks = React.useMemo(
    () => complianceChecklist.filter((topic) => topic.result === ComplianceChecklistItemStatus.Rejected && topic.requiredAt),
    [complianceChecklist],
  );
  const rejectedComplianceTasksRef = React.useRef<SessionComplianceChecklistItem[]>(rejectedComplianceTasks);

  React.useEffect(() => {
    if (rejectedComplianceTasks.length > rejectedComplianceTasksRef.current.length) {
      const newRejectedComplianceTasks = rejectedComplianceTasks
        .filter((newTask) => !rejectedComplianceTasksRef.current.some((currentTask) => currentTask.textLower === newTask.textLower));
      newRejectedComplianceTasks.forEach((topic) => {
        const commandRejected = topic.rejectingCommands.find((command) => command.isDetected);
        if (!commandRejected) {
          console.error('A compliance Task was considered as rejected, but no commands within its rejectingCommands is considered as detected. This should never happen.');
          return;
        }
        sendNotification({
          type: 'rejected-compliance-task',
          title: topic.topic.text,
          command: commandRejected.command.text,
        });
        enqueueSnackbar(t('rejected-compliance-task.title', { title: topic.topic.text, command: commandRejected.command.text }), {
          variant: 'error',
        });
      });
    }
    rejectedComplianceTasksRef.current = rejectedComplianceTasks;
  }, [rejectedComplianceTasks]);
}
